// eslint-disable-next-line import/prefer-default-export
export { default as unstable_ClassNameGenerator } from '@mui/utils/ClassNameGenerator';